/*
 * @Author: your name
 * @Date: 2020-10-22 16:08:39
 * @LastEditTime: 2021-05-18 16:41:21
 * @LastEditors: JDY
 * @Description: In User Settings Edit
 * @FilePath: \new_if_admind:\phpstudy_pro\WWW\lfadmin\src\mixins\tableList.js
 */

export const list = {
  data () {
    return {
      scroll: { x: 2000 },
      size: 'default', // 表格默认密度
      element: '.screenfull' // 全屏dom
    }
  },
  beforeMount () {
    const h = document.documentElement.clientHeight || document.body.clientHeight
    this.scroll.y = h - 128
  },
  methods: {
    /**
     * 筛选：状态筛选
     * params:{}
     * @params
     */
    searchChangeState (e) {
        if (e.target.value !== '0') {
            const { where } = this.params
            where.state = e.target.value // 状态筛选赋值
        } else {
            delete this.params.where.state // 状态全部，删除键
        }
        this.getLists()
    },
    /**
     * @Author: JDY
     * @Date: 2021-04-30 13:37:38
     * @LastEditTime: Do not edit
     * @LastEditors: JDY
     * @Description:日期筛选
     * @param  {*}
     * @return {*}
     * @param {*} values
     * @param {*} name
     */
    handleChangeDate (values, name, extra) {
        // console.log(values)
        this.params.page = 1
        this.pagination.current = 1 // 分页重置
        const arr = name || ['created_at_start', 'created_at_end']
        // console.log(arr)
        if (values.length !== 0) {
            const start = this.moment(values[0]).format('YYYY-MM-DD') // 日期格式转换
            const end = this.moment(values[1]).format('YYYY-MM-DD') // 日期格式转换
            this.params.where[arr[0]] = start
            this.params.where[arr[1]] = end
        } else {
            delete this.params.where[arr[0]] // 清空日期删除键
            delete this.params.where[arr[1]]
        }
        this.getLists(extra)
    },
    // 点击分页及筛选
    handleTableChange (pagination, filters, sorter) {
      const { params } = this
      const sort = params.sort ? params.sort : {}
      if (Object.keys(sorter).length !== 0 && sorter.order && sorter.field) {
        sort[sorter.field] = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.params.sort = sort
        this.getLists()
      } else {
        delete params.sort
        this.params = params
      }
    },
    /**
     * toolbar点击
     * @change
     */
    toolBarChange (size, setting) {
        if (size) {
            this.size = size
        }
        if (setting) {
            this.columns = setting
        }
    }
  }

}
export default list
